var stockistSearch =  document.getElementById('stockistSearch');
if (typeof(stockistSearch) != 'undefined' && stockistSearch != null) {

    let origin = document.getElementById("origin");

    /**
     Enable Search by Postcode button if postcode input has a value
     */
    if ( origin ) {

        document.getElementById("origin").addEventListener("keyup", function() {
            var nameInput = document.getElementById('origin').value;
            if (nameInput != "") {
                document.getElementById('postcode-search').removeAttribute("disabled");
            } else {
                document.getElementById('postcode-search').setAttribute("disabled", null);
            }
        });
    }

    var LRmap, LRinfoWindow;

    let stockistLocatorMap = document.getElementById("stockist-locator-map");

    function initMap() {

        if (stockistLocatorMap) {

            let loclat = document.getElementById("loclat");
            let stockistLocatorMap = document.getElementById('stockist-locator-map');

            if (loclat && loclat.value) {
                lat = parseFloat(document.getElementById("loclat").value);
            }

            else if ( stockistLocatorMap && stockistLocatorMap.getAttribute('data-lat')) {
                lat = parseFloat(document.getElementById('stockist-locator-map').getAttribute('data-lat'));
            }

            else if (stockist_locator_map_vars.latitude) {
                lat = parseFloat(stockist_locator_map_vars.latitude);
            }

            else {
                lat = 51.5072;
            }

            let loclng = document.getElementById("loclng");


            if (loclng && loclng.value) {
                lng = parseFloat(document.getElementById("loclng").value);
            }

            else if ( stockistLocatorMap && stockistLocatorMap.getAttribute('data-lng')) {
                lng = parseFloat(document.getElementById('stockist-locator-map').getAttribute('data-lng'));
            }

            else if (stockist_locator_map_vars.longitude) {
                lng = parseFloat(stockist_locator_map_vars.longitude );
            }

            else {
                lng = 0.1276;
            }

            let LRzoom = document.getElementById("zoomlevel");

            LRmap = new google.maps.Map(document.getElementById("stockist-locator-map"), {
                center: {
                    lat: lat,
                    lng: lng
                },
                zoom: LRzoom && LRzoom.value ? parseInt(document.getElementById("zoomlevel").value) : 8,

            });


            LRinfoWindow = new google.maps.InfoWindow();

            locationButton = document.getElementById("custom-map-control-button");

            locationButton.addEventListener("click", function() {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(

                        function(position) {
                            const pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };

                            document.getElementById("loclat").value = pos.lat;
                            document.getElementById("loclng").value = pos.lng;

                            let proximity = document.getElementById("proximity").value;
                            let zoom = document.getElementById("zoomlevel");

                            if ( window.innerWidth > 1024) {

                                switch (proximity) {
                                    case '10':
                                        zoom.value = 11;
                                        break;
                                    case '20':
                                        zoom.value = 10;
                                        break;
                                    case '30':
                                        zoom.value = 10;
                                        break;
                                    case '40':
                                        zoom.value = 9;
                                        break;
                                    case '50':
                                        zoom.value = 9;
                                        break;
                                    case '60':
                                        zoom.value = 8;
                                        break;
                                    case '70':
                                        zoom.value = 8;
                                        break;
                                    case '80':
                                        zoom.value = 8;
                                        break;
                                    case '90':
                                        zoom.value = 8;
                                        break;
                                    case '100':
                                        zoom.value = 7;
                                        break;
                                    default:
                                        zoom.value = 8;
                                }
                            }
                
                            else if ( window.innerWidth < 1024 && window.innerWidth > 641) {
                                switch (proximity) {
                                    case '10':
                                        zoom.value = 10;
                                        break;
                                    case '20':
                                        zoom.value = 9;
                                        break;
                                    case '30':
                                        zoom.value = 8;
                                        break;
                                    case '40':
                                        zoom.value = 8;
                                        break;
                                    case '50':
                                        zoom.value = 7;
                                        break;
                                    case '60':
                                        zoom.value = 7;
                                        break;
                                    case '70':
                                        zoom.value = 7;
                                        break;
                                    case '80':
                                        zoom.value = 7;
                                        break;
                                    case '90':
                                        zoom.value = 7;
                                        break;
                                    case '100':
                                        zoom.value = 7;
                                        break;
                                    default:
                                        zoom.value = 8;
                                }
                            }
                
                            else {
                
                                switch (proximity) {
                                    case '10':
                                        zoom.value = 9;
                                        break;
                                    case '20':
                                        zoom.value = 9;
                                        break;
                                    case '30':
                                        zoom.value = 8;
                                        break;
                                    case '40':
                                        zoom.value = 8;
                                        break;
                                    case '50':
                                        zoom.value = 7;
                                        break;
                                    case '60':
                                        zoom.value = 7;
                                        break;
                                    case '70':
                                        zoom.value = 7;
                                        break;
                                    case '80':
                                        zoom.value = 7;
                                        break;
                                    case '90':
                                        zoom.value = 7;
                                        break;
                                    case '100':
                                        zoom.value = 7;
                                        break;
                                    default:
                                        zoom.value = 7;
                                }
                            }

                            document.getElementById("origin").value = '';
                            document.getElementById("stockistSearch").submit();

                        },

                        function() {
                            handleLocationError(true, LRinfoWindow, LRmap.getCenter());
                        }

                    );

                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, LRmap.getCenter());
                }
            });

            function handleLocationError(browserHasGeolocation, infoWindow, pos) {
                LRinfoWindow.setPosition(pos);
                LRinfoWindow.setContent(
                    browserHasGeolocation
                        ? "Error: The Geolocation service failed."
                        : "Error: Your browser doesn't support geolocation."
                );
                LRinfoWindow.open(LRmap);
            }


            postcodeButton = document.getElementById("postcode-search");

            postcodeButton.addEventListener("click", function() {
                document.getElementById("loclat").value = '';
                document.getElementById("loclng").value = '';
               // document.getElementById("zoomlevel").value = 11;

                let proximity = document.getElementById("proximity").value;
                let zoom = document.getElementById("zoomlevel");
        
                if ( window.innerWidth > 1024) {
        
                    switch (proximity) {
                        case '10':
                            zoom.value = 11;
                            break;
                        case '20':
                            zoom.value = 10;
                            break;
                        case '30':
                            zoom.value = 10;
                            break;
                        case '40':
                            zoom.value = 9;
                            break;
                        case '50':
                            zoom.value = 9;
                            break;
                        case '60':
                            zoom.value = 8;
                            break;
                        case '70':
                            zoom.value = 8;
                            break;
                        case '80':
                            zoom.value = 8;
                            break;
                        case '90':
                            zoom.value = 8;
                            break;
                        case '100':
                            zoom.value = 7;
                            break;
                        default:
                            zoom.value = 8;
                    }
                }
        
                else if ( window.innerWidth < 1024 && window.innerWidth > 641) {
                    switch (proximity) {
                        case '10':
                            zoom.value = 10;
                            break;
                        case '20':
                            zoom.value = 9;
                            break;
                        case '30':
                            zoom.value = 8;
                            break;
                        case '40':
                            zoom.value = 8;
                            break;
                        case '50':
                            zoom.value = 7;
                            break;
                        case '60':
                            zoom.value = 7;
                            break;
                        case '70':
                            zoom.value = 7;
                            break;
                        case '80':
                            zoom.value = 7;
                            break;
                        case '90':
                            zoom.value = 7;
                            break;
                        case '100':
                            zoom.value = 7;
                            break;
                        default:
                            zoom.value = 8;
                    }
                }
        
                else {
        
                    switch (proximity) {
                        case '10':
                            zoom.value = 9;
                            break;
                        case '20':
                            zoom.value = 9;
                            break;
                        case '30':
                            zoom.value = 8;
                            break;
                        case '40':
                            zoom.value = 8;
                            break;
                        case '50':
                            zoom.value = 7;
                            break;
                        case '60':
                            zoom.value = 7;
                            break;
                        case '70':
                            zoom.value = 7;
                            break;
                        case '80':
                            zoom.value = 7;
                            break;
                        case '90':
                            zoom.value = 7;
                            break;
                        case '100':
                            zoom.value = 7;
                            break;
                        default:
                            zoom.value = 7;
                    }
                }
            });
        }
    }

    initMap();

    if (stockistLocatorMap) {


        var i, marker, activeMarker, icon;

        var markers = []; //array to hold the map pins

        /**
         Geolocation pin - If using location determined by Geolocation, show an blue circle pin on the map to indicate current location
         */
        if (document.getElementById("loclat").value || document.getElementById('stockist-locator-map').getAttribute('data-lng') ) {


            if (stockist_locator_map_vars.centre_point ) {
                icon = {
                    url: stockist_locator_map_vars.centre_point,
                    scaledSize: new google.maps.Size(25, 25),
                }
            }

            geoLatitude = document.getElementById("loclat").value ? document.getElementById("loclat").value : document.getElementById('stockist-locator-map').getAttribute('data-lat');
            geoLongitude = document.getElementById("loclng").value ? document.getElementById("loclng").value : document.getElementById('stockist-locator-map').getAttribute('data-lng');

            geoLocation = new google.maps.Marker({
                position: new google.maps.LatLng(geoLatitude, geoLongitude),
                map: LRmap,
                optimized: false,
                clickable: false,
                icon: icon,
            });

            markers.push(geoLocation);
        }


        /**
         Use custom pin if set, otherwise use default pin
         */
        if (stockist_locator_map_vars.map_pin ) {
            icon = {
                url: stockist_locator_map_vars.map_pin,
                scaledSize: new google.maps.Size(stockist_locator_map_vars.map_pin_width, stockist_locator_map_vars.map_pin_height),
            }
        } else {
            icon = {
                url: '/wp-content/themes/laughingdog-woo/graphics/map_marker.svg',
                scaledSize: new google.maps.Size(20, 32),
            }
        }

        /**
         Use custom active pin if set, otherwise use custom pin, otherwise use default pin
         */

        if ( stockist_locator_map_vars.map_pin_active ) {
            activeIcon = {
                url: stockist_locator_map_vars.map_pin_active,
                scaledSize: new google.maps.Size(stockist_locator_map_vars.map_pin_width, stockist_locator_map_vars.map_pin_height),
            }
        } else if ( stockist_locator_map_vars.map_pin ) {
            activeIcon = {
                url: stockist_locator_map_vars.map_pin,
                scaledSize: new google.maps.Size(stockist_locator_map_vars.map_pin_width, stockist_locator_map_vars.map_pin_height),
            }

        } else {
            activeIcon = {
                url: '/wp-content/themes/laughingdog-woo/graphics/map_marker.svg',
                scaledSize: new google.maps.Size(20, 32),
            }
        }


        if(typeof map_radius !== 'undefined') {
            var radius = new google.maps.Circle({
                strokeColor: "#197134",
                strokeOpacity: 1,
                strokeWeight: 4,
                fillColor: "#197134",
                fillOpacity: 0.17,
                map: LRmap,
                center: {
                    lat: map_radius.center.lat,
                    lng: map_radius.center.lng
                },
                radius: parseInt(map_radius.size) * 1609.344
            });
    
            LRmap.fitBounds(radius.getBounds());
        }

        /**
         Add pins for the stockists
         */
        for (i = 0; i < stockists.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(stockists[i][1], stockists[i][2]), //get the first and second items (latitude and longitude)
                map: LRmap,
                optimized: false,
                icon: icon
            });

            markers.push(marker);

            markers[i].setVisible(true);

            infowindow = new google.maps.InfoWindow();

            google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {

                    // check to see if activeMarker is set
                    // if so, set the icon back to the default
                    activeMarker && activeMarker.setIcon(icon);

                    // set the icon for the clicked marker
                    marker.setIcon(activeIcon);

                    // update the value of activeMarker
                    activeMarker = marker;


                    infowindow.setContent(stockists[i][0]);
                    infowindow.open(stockistLocatorMap, marker);
                }
            })(marker, i));
        }
    }
}